import { helper } from '@ember/component/helper';

const joinClasses = helper(([classes]: [(string | null | undefined)[]]) => {
	// remove all null, undefined, empty strings
	// return trimmed

	const cleanClasses: string[] = [];
	classes.forEach((cl) => {
		const trimmedCl = String(cl).trim();
		if (cl && trimmedCl) {
			cleanClasses.push(trimmedCl);
		}
	});

	return cleanClasses.join(' ');
});

export default joinClasses;
